import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { cn } from "@tellescope/ui";
import { Link } from "react-router-dom";
import { useDateFnsFormattersWithLocale } from "@tellescope/ui";
import { EventCard } from "./EventCard";

export interface DayEventListProps {
  date: Date;
  events: TellescopeModelFromName<"calendar_events">[];
  onDayClick?: (() => void) | string;
  getOnEventClick?: (eventId: string) => (() => void) | { to: string; replace?: boolean };
  className?: string;
  timezone?: string;
}

export const DayEventList = ({
  date,
  events,
  onDayClick,
  getOnEventClick,
  className,
  timezone = Intl.DateTimeFormat().resolvedOptions().timeZone,
}: DayEventListProps) => {
  const Component = onDayClick ? (typeof onDayClick === "function" ? "button" : Link) : "div";
  const { format } = useDateFnsFormattersWithLocale();

  return (
    <div className={cn("flex flex-col gap-4", className)} id={`day-header-${format(date, "yyyy-MM-dd")}`}>
      <Component
        to={typeof onDayClick === "string" && typeof Component !== "string" ? onDayClick : ""}
        onClick={typeof onDayClick === "function" && typeof Component === "string" ? onDayClick : undefined}
        className="text-sm font-semibold text-left"
      >
        {format(date, "EEEE, MMMM d, yyyy")}
      </Component>
      <div className="flex flex-col gap-2">
        {events.map((event) => (
          <EventCard key={event.id} event={event} timezone={timezone} onEventClick={getOnEventClick?.(event.id)} />
        ))}
      </div>
    </div>
  );
};
